export function safeReturnPath(value) {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || /[\\\u0000-\u001f]/.test(value)) return '';
  try {
    const parsed = new URL(value, window.location.origin);
    const decoded = decodeURIComponent(parsed.pathname);
    if (parsed.origin !== window.location.origin || decoded.startsWith('//') || /[\\\u0000-\u001f]/.test(decoded) || /^\/(login|auth\/callback)(\/|$)/.test(decoded)) return '';
    return parsed.pathname + parsed.search + parsed.hash;
  } catch { return ''; }
}